import React from 'react'
import { Select } from '@arnsbogroup/react-voicearchive'

export const SCOPE_OPTIONS = [
  { value: 'my', label: 'My orders' },
  { value: 'all', label: 'All orders' },
]

export const DEFAULT_SCOPE = 'my'

/**
 * The My orders / All orders toggle shared by the widgets that have one.
 *
 * "My" means orders where the coordinator is the coordinator or the CC; "All"
 * drops that and falls back to their partner. The default is "my" — these are
 * working lists, and a coordinator opening their dashboard wants their own work.
 *
 * The choice is remembered per widget in localStorage rather than saved server
 * side: it is a view preference, not part of the layout, and `dashboardwidgets`
 * has nowhere to put it. Reset to default does not clear it — see
 * documentation/DASHBOARD_WIDGETS.md.
 */
export const readScope = (widgetId) => {
  const stored = localStorage.getItem(scopeKey(widgetId))

  return SCOPE_OPTIONS.some((option) => option.value === stored) ? stored : DEFAULT_SCOPE
}

export const writeScope = (widgetId, scope) => localStorage.setItem(scopeKey(widgetId), scope)

const scopeKey = (widgetId) => `DashboardWidgetScope_${widgetId}`

const OrderScopeFilter = ({ value, onChange }) => (
  <div className="border-b px-4 py-2">
    <Select
      label="Show:"
      size="xs"
      value={SCOPE_OPTIONS.find((option) => option.value === value) || SCOPE_OPTIONS[0]}
      options={SCOPE_OPTIONS}
      onChange={(option) => onChange(option ? option.value : DEFAULT_SCOPE)}
    />
  </div>
)

export default OrderScopeFilter
